import { useMemo, useState } from "react";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

export type UseInvoiceSummarySectionArgs = {
  hasSerie: boolean;
  hasCliente: boolean;
  hasConcepto: boolean;
};

export function useInvoiceSummarySection({
  hasSerie,
  hasCliente,
  hasConcepto,
}: UseInvoiceSummarySectionArgs) {
  // ===== Estado que antes vivía en el padre (columna derecha)
  const [metodoPago, setMetodoPago] = useState<string>("PUE");
  const [formaPago, setFormaPago] = useState<string>("01");
  const [moneda, _setMoneda] = useState<string>("MXN");
  const [tipoCambio, setTipoCambio] = useState<number>(1);
  const [diasCredito, setDiasCredito] = useState<number | "">(10);

  const [correosFijos, setCorreosFijos] = useState<string[]>([]);
  const [correosExtra, setCorreosExtra] = useState<string[]>([]);

  // ===== Misma regla que tenías: si MXN => tc=1; si no => tc=0
  const setMoneda = (value: string) => {
    _setMoneda(value);
    if (value === "MXN") setTipoCambio(1);
    else setTipoCambio(0);
  };

  // ===== Mismo cómputo de permisos/mensajes
  const canGenerar = hasSerie && hasCliente && hasConcepto;
  const generarTooltip = !hasSerie
    ? "SELECCIONA UNA SERIE."
    : !hasCliente
    ? "SELECCIONA UN SOCIO DE NEGOCIOS."
    : !hasConcepto
    ? "AGREGA AL MENOS UN CONCEPTO."
    : "GENERAR FACTURA";

  // ===== Utilidad que usabas para enviar correos
  const correosParaEnviar = () => {
    const set = new Set<string>([...correosFijos, ...correosExtra]);
    return Array.from(set).filter((e) => EMAIL_REGEX.test(e));
  };

  // ===== Reset idéntico al del padre
  const reset = () => {
    setMetodoPago("PUE");
    setFormaPago("01");
    setMoneda("MXN"); // esto ya setea tipoCambio = 1
    setDiasCredito(10);
    setCorreosExtra([]); // fijos se mantienen según cliente
  };

  return {
    // estado
    metodoPago,
    setMetodoPago,
    formaPago,
    setFormaPago,
    moneda,
    setMoneda,
    tipoCambio,
    setTipoCambio,
    diasCredito,
    setDiasCredito,

    correosFijos,
    setCorreosFijos,
    correosExtra,
    setCorreosExtra,

    // derivados
    canGenerar,
    generarTooltip,

    // utilidades
    correosParaEnviar,
    reset,
  };
}
